<template>
    <div class="sub-header">
        <div class="info" :class="info_class">
            <slot name="pre_content"></slot>

            <p>
                <slot name="content"></slot>
            </p>

            <slot name="pos_content"></slot>
        </div>
    </div>
</template>

<script setup>
  import {defineProps} from 'vue';

  const props = defineProps({
    info_class: {
        default: '',
    }
  })
</script>
